var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 19.3V28l8-4.3z","fill":"#fff","key":0}),React.createElement("path",{"d":"M36 0H12A12 12 0 000 12v24a12 12 0 0012 12h24a12 12 0 0012-12V12A12 12 0 0036 0zm2.9 25.2c0 2.5-.3 5-.3 5a7 7 0 01-1.1 3.1 4.1 4.1 0 01-3 1.4C30.3 35 24 35 24 35s-7.8-.1-10.2-.3a4.9 4.9 0 01-3.3-1.4 6.4 6.4 0 01-1.1-3S9 27.6 9 25.1v-2.4c0-2.5.3-5 .3-5a7 7 0 011.1-3.1 4.2 4.2 0 013-1.4C17.7 13 24 13 24 13s6.3 0 10.5.3a4.4 4.4 0 013 1.3 6.5 6.5 0 011.1 3.2s.3 2.5.3 5z","fill":"#fff","key":1})]);
}

Youtube.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Youtube;

Youtube.default = Youtube;
